import React from "react";
import AccordionSummary from "@mui/material/AccordionSummary";
import { ExpandMore } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import { Accordion, Box } from "@mui/material";
import Link from "src/components/common/Links/Link";
import { SxProps, Theme } from "@mui/system";
import { pluralPharmaciesText } from "src/utils/helpers/pluralization/pluralPharmaciesText";
import Image from "next/image";
import { PharmacyCompaniesItemsSchema } from "src/models/newProduct/getNewProduct";

interface PharmaciesInYourCityProps {
  title?: string;
  sx?: SxProps<Theme>;
  data: PharmacyCompaniesItemsSchema[];
  image: string;
}

const PharmaciesInYourCity: React.FC<PharmaciesInYourCityProps> = ({
  title,
  data,
  sx,
  image,
}) => {
  return (
    <Accordion sx={sx}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Image src={image} alt="иконка" width="25px" height="25px" />
        <Typography
          component="h3"
          fontWeight={500}
          color="primary"
          sx={{ ml: 1 }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ display: "flex", flexWrap: "wrap" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          {data.map((value, index, array) => (
            <Link
              href={value.slug}
              key={value.slug}
              sx={{
                textDecoration: "none",
                fontSize: "13px",
                cursor: "pointer",
                ":hover": {
                  opacity: ".7",
                  textDecoration: "underline",
                },
              }}
            >
              <b>{value.name}</b> - {value.amount}{" "}
              {pluralPharmaciesText(value.amount)}
            </Link>
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default PharmaciesInYourCity;
